export interface CountryDetails {
  name: string;
  code: string;
  countryLayerName: string;
  regionLayerName: string;
  districtLayerName: string;
  regionLabelName: string;
  outReclsLayerName: string | null;
  lulcLayerName: string | null;
  urbanRoadsLayerName: string | null;
  rainfallLayerName: string | null;
  settlementLayerName: string | null;
  suitabilityLayerName: string | null;
  landuseLayerName: string | null;
  elevationLayerName: string | null;
  roadLayerName: string | null;
  mapCenterLongitude: number;
  mapCenterLatitude: number;
  mapZoomLevel: number;
}

export interface FocusAreas {
  technology: number;
  people: number;
  environment: number;
  finance: number;
  institutionsAndMarket: number;
}

export interface PlantSettings {
  wasteCollectionEfficiency: number;
  plantCapacityFactor: number;
  scaleOfPlant: number;
  operationalLife: number;
  truckCapacity: number;
  averageDistance: number;
  selectedFuel: string;
}

export interface PlantLocation {
  coordinate: [number, number];
  name: string;
}

export interface AppState {
  selectedCountry: string;
  selectedRegion: string;
  selectedDistrict: string;
  selectedObjective: string;
  selectedWasteCategory: string;
  selectedWasteType: string;
  selectedBusinessModel: string;
  selectedBusinessModels: string[];
  focusAreas: FocusAreas;
  plantSettings: PlantSettings;
  plantLocation: PlantLocation | null;
}

export interface TagState {
  label: string;
  checked: boolean;
  value?: string;
}

export const INITIAL_STATE: AppState = {
  selectedCountry: "",
  selectedRegion: "",
  selectedDistrict: "",
  selectedObjective: "",
  selectedWasteCategory: "",
  selectedWasteType: "",
  selectedBusinessModel: "",
  selectedBusinessModels: [],
  focusAreas: {
    technology: 50,
    people: 50,
    environment: 50,
    finance: 50,
    institutionsAndMarket: 50,
  },
  plantSettings: {
    wasteCollectionEfficiency: 50,
    plantCapacityFactor: 50,
    scaleOfPlant: 1,
    operationalLife: 1,
    truckCapacity: 1,
    averageDistance: 5,
    selectedFuel: "Diesel",
  },
  plantLocation: null,
};
